import React from 'react';
import { MessageCircle, Mail, Phone, MapPin } from 'lucide-react';

const Contact: React.FC = () => {
  return (
    <section id="contato" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-dark mb-4">Entre em contato</h2>
          <p className="text-gray-500 text-lg">Tire suas dúvidas ou solicite um orçamento. Estamos prontos para ajudar.</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Form */}
          <form className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-brand-dark mb-1">Nome</label>
              <input type="text" className="w-full px-4 py-3 rounded-md border border-gray-100 bg-[#f8f9fb] focus:outline-none focus:ring-2 focus:ring-brand-blue/20" />
            </div>
            <div>
              <label className="block text-sm font-medium text-brand-dark mb-1">E-mail</label>
              <input type="email" className="w-full px-4 py-3 rounded-md border border-gray-100 bg-[#f8f9fb] focus:outline-none focus:ring-2 focus:ring-brand-blue/20" />
            </div>
            <div>
              <label className="block text-sm font-medium text-brand-dark mb-1">Telefone</label>
              <input type="tel" className="w-full px-4 py-3 rounded-md border border-gray-100 bg-[#f8f9fb] focus:outline-none focus:ring-2 focus:ring-brand-blue/20" />
            </div>
            <div>
              <label className="block text-sm font-medium text-brand-dark mb-1">Mensagem</label>
              <textarea rows={4} className="w-full px-4 py-3 rounded-md border border-gray-100 bg-[#f8f9fb] focus:outline-none focus:ring-2 focus:ring-brand-blue/20"></textarea>
            </div>
            <button type="submit" className="w-full bg-brand-dark text-white py-4 rounded-md font-bold hover:bg-opacity-90 transition-all">
              Enviar mensagem
            </button>
          </form>

          {/* Info */}
          <div className="space-y-8">
            <a 
              href="https://wa.me/5519989038450" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-[#25D366] text-white p-8 rounded-2xl flex items-center gap-6 cursor-pointer hover:bg-opacity-95 transition-all block"
            >
              <div className="bg-white/20 p-4 rounded-full">
                <MessageCircle size={32} />
              </div>
              <div>
                <h4 className="text-xl font-bold">Fale pelo WhatsApp</h4>
                <p className="opacity-90">Atendimento rápido e direto</p>
              </div>
            </a>

            <div className="space-y-6 pt-4">
              <div className="flex items-center gap-4 text-gray-600">
                <div className="text-brand-blue"><Mail size={24} /></div>
                <span>contato@dralvara.com.br</span>
              </div>
              <div className="flex items-center gap-4 text-gray-600">
                <div className="text-brand-blue"><Phone size={24} /></div>
                <span>(19) 98903-8450</span>
              </div>
              <div className="flex items-start gap-4 text-gray-600">
                <div className="text-brand-blue pt-1"><MapPin size={24} /></div>
                <span>R. Luís Spiandorelli Neto, 30 - Jardim Paiquere, Valinhos - SP, 13271-570, Sala 206, Torre Paineiras</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
